/*
 *
 *  * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *  *    .       .       .       .       .       .       .       .       .       .       .       .
 *  *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *  *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *  *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *  *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *  *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *  *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *  *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *  *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *  *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *  *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *  *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *  *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *  *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *  *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *  *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *  *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *  *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *  *
 *  * Copyright FortyFix(c) 2025.
 *  * Title: Utility.ts;
 *  * Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/app/shared/_helpers/Utility.ts;
 *  * Description: ;
 *  * Author: Della Porta Giovanni Battista;
 *  * Created at: 11/11/25, 11:16;
 *  * Updated at: 11/11/25, 11:16;
 *
 */
export async function compressImage(file: File, maxSizeMB: number): Promise<File> {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      const image = new Image();

      reader.onload = () => (image.src = reader.result as string);
      reader.onerror = (err) => reject(new Error('Errore durante la lettura del file'));

      image.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) throw new Error('Canvas non supportato');

          let width = image.width;
          let height = image.height;

          // Mantieni proporzioni
          const aspectRatio = width / height;

          // Imposta qualità iniziale
          let quality = 0.9;

          // Funzione di compressione iterativa
          const compress = () => {
            canvas.width = width;
            canvas.height = height;
            ctx.clearRect(0, 0, width, height);
            ctx.drawImage(image, 0, 0, width, height);

            canvas.toBlob(
              (blob) => {
                if (!blob) return reject(new Error('Errore durante la compressione (blob nullo)'));

                const sizeMB = blob.size / 1024 / 1024;
                console.log({

                  fileBytes: file?.size,

                  fileMB: file?.size / 1024 / 1024,

                  blobBytes: blob?.size,

                  blobMB: blob?.size / 1024 / 1024

                });

                if (sizeMB > maxSizeMB) {
                  // Prima riduci qualità
                  if (quality > 0.2) {
                    quality -= 0.1;
                    console.log('Riduzione qualità da',quality+0.1,'  a', quality);
                  }
                  // Se qualità troppo bassa, riduci risoluzione
                  else if (width > 200 && height > 200) {
                    width = Math.floor(width * 0.9);
                    height = Math.floor(width / aspectRatio);
                  }
                  // Se non si riesce più a ridurre → risoluzione minima raggiunta
                  else {
                    console.warn('Impossibile comprimere ulteriormente sotto', maxSizeMB, 'MB');
                    const compressedFile = new File(
                      [blob],
                      file.name.replace(/\.[^/.]+$/, '.jpg'),
                      { type: 'image/jpeg' }
                    );
                    resolve(compressedFile);
                    return;
                  }

                  compress(); // ripeti compressione con nuovi parametri
                } else {
                  console.log('Immagine compressa con qualità', quality);
                  console.log('Immagine compressa con peso', sizeMB);
                  const compressedFile = new File(
                    [blob],
                    file.name.replace(/\.[^/.]+$/, '.jpg'),
                    { type: 'image/jpeg' }
                  );
                  resolve(compressedFile);
                }
              },
              'image/jpeg',
              quality
            );
          };

          compress();
        } catch (err) {
          reject(err);
        }
      };

      image.onerror = (err) => reject(new Error('Errore nel caricamento immagine: probabilmente non supportata o danneggiata'));

      reader.readAsDataURL(file);
    } catch (err) {
      reject(err);
    }
  });
}

export function checkAspectRatio(
  h: number,
  l: number,
  imgSrc: string,
  tolerance: number
): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = imgSrc;

    const check = () => {
      const aspectRatio = img.width / img.height;
      const targetRatio = l / h;
      const delta = targetRatio * (tolerance / 100);
      console.log('Aspetto dell\'immagine',  "aspectRatio",  aspectRatio,
        "targetRatio" ,  targetRatio, "Width:",  img.width, "Height:", img.height );

      resolve(
        aspectRatio >= (targetRatio - delta) &&
        aspectRatio <= (targetRatio + delta)
      );
    };

    if (img.complete) {
      check();
    } else {
      img.onload = check;
    }
  });
}
